import { type Connector } from 'wagmi';

import { availableConnectors, type Web3WagmiConnectors } from './types';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function getConnector(wagmiConnectors: Connector<any, any>[], connectorName: Web3WagmiConnectors) {
    const connectorIndex = availableConnectors.indexOf(connectorName);
    return wagmiConnectors[connectorIndex];
}
